import { render } from "./Wave.vue?vue&type=template&id=1a0f1f1b&scoped=true"
import script from "./Wave.vue?vue&type=script&lang=js"
export * from "./Wave.vue?vue&type=script&lang=js"

import "./Wave.vue?vue&type=style&index=0&id=1a0f1f1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0f1f1b"]])

export default __exports__